import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/datasources/connectWebhook';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// Create a push (webhook) event source.
function* operation(action) {
  try {
    const res = yield call(
      axios.post,
      `${config.API_URL}/ingestion/connect/create-event`,
      action.payload.body,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(res.data?.data || res.data));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(error.response?.data?.error || error.message || 'Failed to create webhook.'));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
